import styled from "styled-components";

export const VideoUploadStyle = styled.div`
    .container{

    }
`